// Please: Alphabetize the exports

export const USER_GROUP_TYPE = 'UserGroup'

export const OPEN_ASSIGN_POPUP_SCOPES = {
  people: 'people',
  groups: 'groups'
}
